import * as React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import AdDataRouteManager from './ad/AdDataRouteManager';
import { ROUTE_PATH } from '../../constants';
import { useSelector } from 'react-redux';
import { sessionSelector } from '../../reducers/session';
import { VIEW_TYPE as FLOW_TYPE } from './flow/flowdata_constants';

export type Props = RouteComponentProps;

/**
 * The root component for the /data route that manages the route URL state and filters
 */
const DataRouteManager: React.FunctionComponent<Props> = (props) => {
  const additionalDataEnabled = useSelector(
    sessionSelector.isFeatureFlagEnabled('additional_data'),
  );
  const orgID = useSelector(sessionSelector.getRiskID);

  return (
    <Switch>
      <Route
        path={`${ROUTE_PATH.DATA.FLOW}/:type(${FLOW_TYPE.DEVICE}|${FLOW_TYPE.PROTOCOL}|${FLOW_TYPE.LOCATION}|${FLOW_TYPE.SITE}|${FLOW_TYPE.SENSOR})`}
        render={(routeProps) => {
          const { type } = routeProps.match.params;
          const searchParams = new URLSearchParams(routeProps.location.search);
          if (orgID) {
            searchParams.append('id', orgID);
          }

          const url = new URL(
            `${ROUTE_PATH.DASHBOARD.UNIFIED}/data-explorer/flow/${type}`,
          );
          url.search = searchParams.toString();

          window.location.href = url.toString();
        }}
      />
      {additionalDataEnabled && (
        <Route path={ROUTE_PATH.DATA.AD} component={AdDataRouteManager} />
      )}
      <Route
        render={() => {
          const searchParams = new URLSearchParams();
          if (orgID) {
            searchParams.append('id', orgID);
          }
          const url = new URL(
            `${ROUTE_PATH.DASHBOARD.UNIFIED}/data-explorer/flow/${FLOW_TYPE.DEVICE}`,
          );
          url.search = searchParams.toString();
          window.location.href = url.toString();
        }}
      />
    </Switch>
  );
};

export default DataRouteManager;
